import ContextCard from '@/components/ContextCard/ContextCard'
import rowStyles from '@/components/ContextCard/contextCardRow.module.scss'
import copyStyles from '@/components/ContextCard/contextCardCopy.module.scss'

export default function AutomationCardError({ error }) {
  return (
    <ContextCard activity="automation" title="Created automation" plain medium>
      <div className={`${rowStyles.row} ${rowStyles.rowStack}`}>
        <p className={copyStyles.app}>Could not save that schedule</p>
        <p className={copyStyles.permLead}>{error || 'Try describing the task again.'}</p>
      </div>
    </ContextCard>
  )
}
